import { Tolgee, TolgeeInstance } from '@tolgee/react';
import { FormatIcu } from '@tolgee/format-icu';
import { DEFAULT_LOCALE } from './config';
import { asyncLocaleLoaders } from './localeLoaders';
import { addInContextToolsIfRequested } from './inContext';

export const TOLGEE_API_URL = 'https://i18n.mylingu.com';

export const tolgee: TolgeeInstance = Tolgee().use(FormatIcu()).init({
  language: DEFAULT_LOCALE,
  fallbackLanguage: 'en',
  // URL only — never an apiKey: regular users make zero Tolgee API calls
  // (translations are static JSON pulled at build time). The URL lets the
  // Tolgee Tools browser extension pre-fill the server address; in-context
  // editing activates only when the extension supplies credentials.
  apiUrl: TOLGEE_API_URL,
  // Locale files are pulled from Tolgee (`npm run translations:pull`) and
  // fully gitignored: every language loads as a lazy chunk, and languages
  // missing from the local checkout fall back to `en` at runtime.
  staticData: asyncLocaleLoaders
});

addInContextToolsIfRequested(tolgee);

// Debugging handle for local development only — statically eliminated from
// production builds (import.meta.env is not usable here because ts-jest
// compiles this module for tests).
if (process.env.NODE_ENV === 'development') {
  (window as unknown as Record<string, unknown>).__appTolgee = tolgee;
}
